import { useSite } from "../context/SiteContext";
import { Reveal, ChapterTag, SectionTitle } from "./Reveal";
import { DynIcon } from "../lib/icons";

export function Advantages() {
  const { content } = useSite();
  const items = content?.advantages || [];

  return (
    <section id="keunggulan" data-testid="advantages-section" className="relative py-24 sm:py-32 bg-navy-900 noise-overlay">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterTag number="04" label="Keunggulan" />
        <div className="mb-14">
          <SectionTitle>Kenapa <span className="text-ice">Memilih Kami?</span></SectionTitle>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((a, i) => (
            <Reveal key={a.id || i} delay={0.05 * (i % 4)}>
              <div
                data-testid={`advantage-card-${i}`}
                className="group h-full bg-navy-950/70 border border-glacier/15 rounded-sm p-6 hover:border-ice/50 hover:-translate-y-1 transition-all duration-300"
              >
                <span className="inline-flex w-11 h-11 rounded-sm bg-navy-800 border border-glacier/25 items-center justify-center group-hover:border-ice/60 group-hover:glow-ice transition-all duration-300">
                  <DynIcon name={a.icon} className="w-5 h-5 text-ice" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold uppercase tracking-wide text-frost">{a.title}</h3>
                <p className="mt-2 text-sm text-steel leading-relaxed">{a.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
